import { Link, useLocation } from 'react-router-dom';

import { ROUTE_PATHS } from '@dmp/constant';

import type { NavigationLinksProps } from '../GlobalHeader.types';
import { getActiveClass, shouldShowAgencyCatalog } from '../GlobalHeader.utils';
import { ExpertDataServiceDropdown } from './ExpertDataServiceDropdown';

/**
 * Navigation links component
 * Renders the main navigation links in the header
 * Conditionally shows Agency Catalog for Centific users only
 */
export const NavigationLinks = ({ isLoggedIn, userEmail }: NavigationLinksProps) => {
  const location = useLocation();
  const showAgencyCatalog = shouldShowAgencyCatalog(isLoggedIn, userEmail);

  const linkBaseClass = 'text-[#333] text-sm hover:text-[#0038FF] transition-colors pb-1 whitespace-nowrap';

  return (
    <div className="flex items-center gap-3 md:gap-4 lg:gap-8 flex-nowrap px-2">
      {/* Agency Catalog - Only for Centific users */}
      {showAgencyCatalog && (
        <Link
          to={ROUTE_PATHS.AGENCY_CATALOG}
          rel="noopener noreferrer"
          className={linkBaseClass}
          data-testid="agency-catalog-link"
        >
          Agency Catalog
        </Link>
      )}

      {/* Expert Data Service - Dropdown */}
      <ExpertDataServiceDropdown />

      {/* Partners */}
      <Link
        to={ROUTE_PATHS.PARTNERS}
        className={`${linkBaseClass} ${getActiveClass(location.pathname, ROUTE_PATHS.PARTNERS)}`}
        data-testid="partners-link"
      >
        {location.pathname === ROUTE_PATHS.PARTNERS ? 'Partnership' : 'Partners'}
      </Link>

      {/* Contact Us */}
      <Link
        to={ROUTE_PATHS.CONTACT_SALES_TEAM}
        className={`${linkBaseClass} ${getActiveClass(location.pathname, ROUTE_PATHS.CONTACT_SALES_TEAM)}`}
        data-testid="contact-us-link"
      >
        Contact Us
      </Link>
    </div>
  );
};
